export default [
	{
		type: "uni",
		id: 1,
		items: [
			{
				id: 1,
				text: "Das Lernziel wurde mir deutlich.",
			},
			{
				id: 2,
				text: "Die angestrebten Lernziele der Sitzungen  wurden von vorneherein gut definiert.",
			},
			{
				id: 3,
				text: "Ich hatte das Gefühl, die bisherigen Veranstaltungen haben mich gut auf die geforderten Aufgaben vorbereitet.",
			},
			{
				id: 4,
				text: "Ich konnte psychotherapeutische Basisfertigkeiten in angemessenem Rahmen üben.",
			},
			{
				id: 5,
				text: "Der Selbsterfahrungsanteil war angemessen.",
			},
			{
				id: 6,
				text: "Das Fallseminar hat mich gut auf die Approbationsprüfung vorbereitet.",
			},
		],
	},
	{
		type: "bi",
		id: 2,
		items: [
			{
				id: 7,
				text: "Die Anforderungen der Veranstaltung waren...",
			},
			{
				id: 8,
				text: "Der Zeitaufwand für die Veranstaltung insgesamt (inkl. Vor- und Nachbereitung) war...",
			},
			{
				id: 9,
				text: "Insgesamt empfand ich die Veranstaltung als...",
			},
		],
	},
	{
		type: "uni",
		id: 3,
		items: [
			{
				id: 10,
				text: "Insgesamt fand ich die Veranstaltung gut.",
			},
			{
				id: 11,
				text: "In der Veranstaltung habe ich viel gelernt.",
			},
			{
				id: 12,
				text: "Meine Erwartungen an die Veranstaltung wurden erfüllt.",
			},
		],
	},
	{
		type: "text",
		id: 4,
		items: [
			{
				id: 13,
				text: "Hätten Sie sich darüber hinaus etwas von Ihrer/Ihren anleitende/n Person/en gewünscht?",
			},
			{
				id: 14,
				text: "Haben Sie Verbesserungs-/Veränderungsvorschläge?",
			},
			{
				id: 15,
				text: "Weitere Anmerkungen",
			},
		],
	},
	{
		type: "dsp",
		id: 5,
		items: [
			{
				id: 16,
				text: "Die anleitende/n Person/en waren engagiert und motiviert.",
			},
			{
				id: 17,
				text: "Die anleitende/n Person/en konnte/n meine Fragen kompetent beantworten.",
			},
			{
				id: 18,
				text: "Die anleitende/n Person/en hat/haben therapeutische Inhalte angemessen nachbesprochen.",
			},
			{
				id: 19,
				text: "Die anleitende/n Person/en war/en ein gutes therapeutisches Arbeitsmodell für mich.",
			},
		],
	},
];
